<template>
  <MainLayout>
    <ContentPageHeader functionName="外部連携" pageName="テスト画面">
    </ContentPageHeader>
    
    <!-- <div v-if="!isAdmin" class="permission-error">
      <div class="alert alert-danger">
        <i class="fas fa-exclamation-triangle"></i>
        このページは管理者のみアクセスできます。
      </div>
    </div> -->

    <!-- <div v-if="isAdmin"> -->
      <!-- バッチ処理実行ボタン -->
      <div class="batch-section">
        <button class="btn btn-warning" @click="executeDeleteOldSoldProducts">
          発送後指定時間以上経過した商品を削除
        </button>
        
        <!-- バッチ処理結果表示 -->
        <div class="result-section" v-if="batchResult" style="margin-top: 15px;">
          <div class="result-container" :class="{'success': batchResult.success, 'error': !batchResult.success}">
            <div class="result-message">{{ batchResult.message }}</div>
          </div>
        </div>
      </div>
      
      <!-- タブ切り替え -->
      <div class="tabs-container">
        <div class="tabs">
          <div 
            class="tab" 
            :class="{ 'active': activeTab === 'mercari' }"
            @click="activeTab = 'mercari'"
          >
            メルカリShops
          </div>
          <div 
            class="tab" 
            :class="{ 'active': activeTab === 'shopify' }"
            @click="activeTab = 'shopify'"
          >
            Shopify
          </div>
          <div 
            class="tab" 
            :class="{ 'active': activeTab === 'smaregi' }"
            @click="activeTab = 'smaregi'"
          >
            スマレジ
          </div>
        </div>
      </div>
      
      <!-- メルカリShopsテスト -->
      <div v-if="activeTab === 'mercari'">
        <!-- 商品ID入力セクション -->
        <div class="test-section">
          <div class="form-field-container">
            <label class="form-label">商品ID</label>
            <div class="required-mark-container"></div>
            <div class="input-container">
              <input 
                type="number" 
                v-model="mercariProductId" 
                placeholder="商品IDを入力してください"
                class="form-control"
              />
            </div>
          </div>
          
          <!-- 操作ボタン -->
          <div class="action-buttons">
            <button class="btn btn-primary" @click="registerMercariProduct" :disabled="!mercariProductId">商品登録</button>
            <button class="btn btn-primary" @click="updateMercariProduct" :disabled="!mercariProductId">商品更新</button>
            <button class="btn btn-danger" @click="deleteMercariProduct" :disabled="!mercariProductId">商品削除</button>
            <button class="btn btn-primary" @click="createMercariOrder" :disabled="!mercariProductId">注文情報登録</button>
          </div>
        </div>
        
        <!-- 注文処理セクション -->
        <div class="test-section" style="margin-top: 20px;">
          <h5>注文処理</h5>
          <div class="form-field-container">
            <label class="form-label">注文ID</label>
            <div class="input-container">
              <input 
                type="text" 
                v-model="orderId" 
                placeholder="注文IDを入力してください"
                class="form-control"
              />
            </div>
          </div>
          
          <div class="action-buttons">
            <button class="btn btn-secondary" @click="getMercariOrderInfo">注文情報取得</button>
            <button class="btn btn-primary" @click="completeOrder" :disabled="!orderId">発送済にする</button>
          </div>
          
          <div v-if="createdOrderId" class="result-section" style="margin-top: 15px;">
            <h6>登録された注文ID</h6>
            <div style="padding: 10px; background-color: #f8f9fa; border-radius: 4px; font-family: monospace;">
              {{ createdOrderId }}
            </div>
          </div>
        </div>
        
        <!-- Webhook登録セクション -->
        <div class="test-section" style="margin-top: 20px;">
          <h5>Webhook登録</h5>
          <div class="form-field-container">
            <label class="form-label">Topic</label>
            <div class="input-container">
              <input 
                type="text" 
                v-model="webhookTopic" 
                placeholder="ORDER_TRANSACTION_CREATED, ORDER_TRANSACTION_PAID, etc."
                class="form-control"
              />
            </div>
          </div>
          
          <div class="form-field-container">
            <label class="form-label">Endpoint URL</label>
            <div class="input-container">
              <input 
                type="text" 
                v-model="webhookEndpoint" 
                placeholder="https://example.com/webhook"
                class="form-control"
              />
            </div>
          </div>
          
          <div class="action-buttons">
            <button class="btn btn-primary" @click="registerWebhook" :disabled="!webhookEndpoint">Webhook登録</button>
            <button class="btn btn-secondary" @click="getWebhookList">Webhook一覧取得</button>
          </div>
        </div>
        
        <!-- 結果表示セクション -->
        <div class="result-section" v-if="mercariResult">
          <h4>実行結果</h4>
          <div class="result-container" :class="{'success': mercariResult.success, 'error': !mercariResult.success}">
            <div class="result-message">{{ mercariResult.message }}</div>
            
            <div class="result-details" v-if="mercariResult.success && mercariResult.status">
              <h5>商品情報</h5>
              <table class="result-table">
                <tbody>
                  <tr>
                    <th>ステータス</th>
                    <td>{{ mercariResult.status }}</td>
                  </tr>
                  <tr v-if="mercariResult.itemCode">
                    <th>商品コード</th>
                    <td>{{ mercariResult.itemCode }}</td>
                  </tr>
                  <tr v-if="mercariResult.name">
                    <th>商品名</th>
                    <td>{{ mercariResult.name }}</td>
                  </tr>
                  <tr v-if="mercariResult.description">
                    <th>商品説明</th>
                    <td>{{ mercariResult.description }}</td>
                  </tr>
                  <tr v-if="mercariResult.price">
                    <th>価格</th>
                    <td>¥{{ mercariResult.price }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        
        <!-- Webhook一覧表示セクション -->
        <div v-if="webhooks.length > 0" class="result-section" style="margin-top: 20px;">
          <h4>登録済みWebhook一覧</h4>
          <table class="result-table webhook-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Topic</th>
                <th>Endpoint</th>
                <th>API Version</th>
                <th>作成日時</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="webhook in webhooks" :key="webhook.id">
                <td>{{ webhook.id }}</td>
                <td>{{ webhook.topic }}</td>
                <td>{{ webhook.endPoint }}</td>
                <td>{{ webhook.apiVersion }}</td>
                <td>{{ webhook.createdAt }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        
        <!-- 注文一覧表示セクション -->
        <div v-if="orders.length > 0" class="result-section" style="margin-top: 20px;">
          <h4>注文一覧</h4>
          <table class="result-table order-table">
            <thead>
              <tr>
                <th>商品コード</th>
                <th>商品名</th>
                <th>価格</th>
                <th>支払い方法</th>
                <th>ステータス</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(order, index) in orders" :key="index">
                <td>{{ order.itemCode }}</td>
                <td>{{ order.name }}</td>
                <td>{{ order.price ? order.price.toLocaleString() + '円' : '-' }}</td>
                <td>{{ order.paymentMethod || '-' }}</td>
                <td>{{ order.status || '-' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      
      <!-- Shopifyテスト -->
      <div v-if="activeTab === 'shopify'">
        <!-- 商品ID入力セクション -->
        <div class="test-section">
          <div class="form-field-container">
            <label class="form-label">商品ID</label>
            <div class="required-mark-container"></div>
            <div class="input-container">
              <input 
                type="number" 
                v-model="shopifyProductId" 
                placeholder="商品IDを入力してください"
                class="form-control"
              />
            </div>
          </div>
          
          <!-- 操作ボタン -->
          <div class="action-buttons">
            <button class="btn btn-primary" @click="registerShopifyProduct" :disabled="!shopifyProductId">商品登録</button>
            <button class="btn btn-primary" @click="updateShopifyProduct" :disabled="!shopifyProductId">商品更新</button>
            <button class="btn btn-danger" @click="deleteShopifyProduct" :disabled="!shopifyProductId">商品削除</button>
            <button class="btn btn-secondary" @click="getShopifyProductInfo" :disabled="!shopifyProductId">商品情報取得</button>
            <button class="btn btn-primary" @click="bulkRegisterShopifyProduct">一括商品登録</button>
          </div>
        </div>
        
        <!-- 結果表示セクション -->
        <div class="result-section" v-if="shopifyResult">
          <h4>実行結果</h4>
          <div class="result-container" :class="{'success': shopifyResult.success, 'error': !shopifyResult.success}">
            <div class="result-message">{{ shopifyResult.message }}</div>
            
            <div class="result-details" v-if="shopifyResult.success && shopifyResult.status">
              <h5>商品情報</h5>
              <table class="result-table">
                <tbody>
                  <tr>
                    <th>ステータス</th>
                    <td>{{ shopifyResult.status }}</td>
                  </tr>
                  <tr v-if="shopifyResult.itemCode">
                    <th>商品コード</th>
                    <td>{{ shopifyResult.itemCode }}</td>
                  </tr>
                  <tr v-if="shopifyResult.name">
                    <th>商品名</th>
                    <td>{{ shopifyResult.name }}</td>
                  </tr>
                  <tr v-if="shopifyResult.description">
                    <th>商品説明</th>
                    <td>{{ shopifyResult.description }}</td>
                  </tr>
                  <tr v-if="shopifyResult.price">
                    <th>価格</th>
                    <td>¥{{ shopifyResult.price }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      
      <!-- スマレジテスト -->
      <div v-if="activeTab === 'smaregi'">
        <!-- 商品ID入力セクション -->
        <div class="test-section" style="margin-top: 20px;">
          <div class="form-field-container">
            <label class="form-label">商品ID</label>
            <div class="required-mark-container"></div>
            <div class="input-container">
              <input 
                type="number" 
                v-model="smaregiProductId" 
                placeholder="商品IDを入力してください"
                class="form-control"
              />
            </div>
          </div>
          
          <!-- 操作ボタン -->
          <div class="action-buttons">
            <button class="btn btn-primary" @click="registerSmaregiProduct" :disabled="!smaregiProductId">商品登録</button>
            <button class="btn btn-primary" @click="updateSmaregiProduct" :disabled="!smaregiProductId">商品在庫更新</button>
            <button class="btn btn-danger" @click="deleteSmaregiProduct" :disabled="!smaregiProductId">商品削除</button>
            <button class="btn btn-secondary" @click="getSmaregiOrderInfo">注文情報取得</button>
            <button class="btn btn-danger" @click="bulkDeleteAllSmaregiProducts">全商品削除</button>
            <button class="btn btn-warning" @click="bulkRegisterSmaregiProducts">商品一括登録</button>
          </div>
        </div>
        
        <!-- スマレジ商品ID登録セクション -->
        <div class="test-section" style="margin-top: 20px;">
          <h5>スマレジ商品ID登録</h5>
          <div class="form-field-container">
            <label class="form-label">CSVファイル（商品ID,商品コード）</label>
            <div class="input-container">
              <input 
                type="file" 
                ref="smaregiCsvFile"
                accept=".csv"
                @change="onSmaregiCsvFileChange"
                class="form-control"
              />
            </div>
          </div>
          <div class="action-buttons">
            <button class="btn btn-info" @click="uploadSmaregiProductIds" :disabled="!smaregiCsvFile">スマレジ商品ID登録</button>
          </div>
        </div>
        
        <!-- CSV出力セクション -->
        <div class="test-section" style="margin-top: 20px;">
          <h5>CSV出力</h5>
          <div class="action-buttons">
            <button class="btn btn-success" @click="exportSmaregiCsv">CSV出力（ZIP）</button>
          </div>
        </div>
        
        <!-- 結果表示セクション -->
        <div class="result-section" v-if="smaregiResult">
          <h4>実行結果</h4>
          <div class="result-container" :class="{'success': smaregiResult.success, 'error': !smaregiResult.success}">
            <div class="result-message">{{ smaregiResult.message }}</div>
          </div>
        </div>
        
        <!-- 注文一覧表示セクション -->
        <div v-if="smaregiOrders.length > 0" class="result-section" style="margin-top: 20px;">
          <h4>注文一覧</h4>
          <table class="result-table order-table">
            <thead>
              <tr>
                <th>商品コード</th>
                <th>商品名</th>
                <th>価格</th>
                <th>支払い方法</th>
                <th>ステータス</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(order, index) in smaregiOrders" :key="index">
                <td>{{ order.itemCode }}</td>
                <td>{{ order.name }}</td>
                <td>{{ order.price ? order.price.toLocaleString() + '円' : '-' }}</td>
                <td>{{ order.paymentMethod || '-' }}</td>
                <td>{{ order.status || '-' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    <!-- </div> -->
  </MainLayout>
</template>

<script>
import MainLayout from '@/components/layout/MainLayout.vue'
import ContentPageHeader from '@/components/layout/ContentPageHeader.vue'
import service from '../../services/service'
import constants from '../../constants/constants.json'

export default {
  name: 'ExternalShopsTestView',
  components: {
    MainLayout,
    ContentPageHeader
  },
  data() {
    return {
      activeTab: 'mercari',
      mercariProductId: '',
      shopifyProductId: '',
      smaregiProductId: '',
      mercariResult: null,
      shopifyResult: null,
      smaregiResult: null,
      webhookTopic: 'ORDER_TRANSACTION_CREATED',
      webhookEndpoint: '',
      orderId: '',
      webhooks: [],
      orders: [],
      smaregiOrders: [],
      createdOrderId: null,
      batchResult: null,
      smaregiCsvFile: null
    }
  },
  computed: {
    isAdmin() {
      const user = this.$store.getters['auth/currentUser'];
      return user && user.authority === constants.Authority.ADMIN.id;
    }
  },
  methods: {
    // メルカリShops関連メソッド
    async registerMercariProduct() {
      try {
        this.mercariResult = null;
        const response = await service.registerToMercari(this.mercariProductId);
        this.mercariResult = response.data;
      } catch (error) {
        this.handleMercariError(error);
      }
    },
    
    async updateMercariProduct() {
      try {
        this.mercariResult = null;
        const response = await service.updateToMercari(this.mercariProductId);
        this.mercariResult = response.data;
      } catch (error) {
        this.handleMercariError(error);
      }
    },
    
    async deleteMercariProduct() {
      try {
        this.mercariResult = null;
        const response = await service.deleteToMercari(this.mercariProductId);
        this.mercariResult = response.data;
      } catch (error) {
        this.handleMercariError(error);
      }
    },
    
    async getMercariOrderInfo() {
      try {
        this.mercariResult = null;
        this.orders = [];
        const response = await service.ordersToMercari();
        this.mercariResult = response.data;
        if (response.data.success && response.data.orders) {
          this.orders = response.data.orders;
        }
      } catch (error) {
        this.handleMercariError(error);
      }
    },
    
    async createMercariOrder() {
      try {
        this.mercariResult = null;
        this.createdOrderId = null;
        const response = await service.createOrderToMercari(this.mercariProductId);
        this.mercariResult = response.data;
        if (response.data.success && response.data.orderId) {
          this.createdOrderId = response.data.orderId;
        }
      } catch (error) {
        this.handleMercariError(error);
      }
    },
    
    async registerWebhook() {
      try {
        this.mercariResult = null;
        const response = await service.registerWebhookToMercari({
          topic: this.webhookTopic,
          endPoint: this.webhookEndpoint
        });
        this.mercariResult = response.data;
      } catch (error) {
        this.handleMercariError(error);
      }
    },
    
    async getWebhookList() {
      try {
        this.mercariResult = null;
        this.webhooks = [];
        const response = await service.getWebhooksFromMercari();
        this.mercariResult = response.data;
        if (response.data.success && response.data.webhooks) {
          this.webhooks = response.data.webhooks;
        }
      } catch (error) {
        this.handleMercariError(error);
      }
    },
    
    async completeOrder() {
      try {
        this.mercariResult = null;
        const response = await service.completeOrderToMercari(this.orderId);
        this.mercariResult = response.data;
      } catch (error) {
        this.handleMercariError(error);
      }
    },
    
    handleMercariError(error) {
      console.error('メルカリAPI呼び出しエラー:', error);
      this.mercariResult = {
        success: false,
        message: error.response?.data?.message || 'APIの呼び出しに失敗しました'
      };
    },
    
    // Shopify関連メソッド
    async registerShopifyProduct() {
      try {
        this.shopifyResult = null;
        const response = await service.registerToShopify(this.shopifyProductId);
        this.shopifyResult = response.data;
      } catch (error) {
        this.handleShopifyError(error);
      }
    },
    
    async updateShopifyProduct() {
      try {
        this.shopifyResult = null;
        const response = await service.updateToShopify(this.shopifyProductId);
        this.shopifyResult = response.data;
      } catch (error) {
        this.handleShopifyError(error);
      }
    },
    
    async deleteShopifyProduct() {
      try {
        this.shopifyResult = null;
        const response = await service.deleteToShopify(this.shopifyProductId);
        this.shopifyResult = response.data;
      } catch (error) {
        this.handleShopifyError(error);
      }
    },

    async bulkRegisterShopifyProduct() {
      // 確認ダイヤログの表示
      if (!confirm('Shopifyに全ての商品を一括登録します。よろしいですか？')) {
        return;
      }
      try {
        service.bulkRegisterToShopify();
        this.shopifyResult = {
          success: true,
          message: '一括登録を開始しました。処理には時間がかかる場合があります。'
        };
      } catch (error) {
        this.handleShopifyError(error);
      }
    },

    async getShopifyProductInfo() {
      try {
        this.shopifyResult = null;
        const response = await service.registerToShopify(this.shopifyProductId);
        this.shopifyResult = response.data;
      } catch (error) {
        this.handleShopifyError(error);
      }
    },
    
    handleShopifyError(error) {
      console.error('ShopifyAPI呼び出しエラー:', error);
      this.shopifyResult = {
        success: false,
        message: error.response?.data?.message || 'APIの呼び出しに失敗しました'
      };
    },
    
    async registerSmaregiProduct() {
      try {
        this.smaregiResult = null;
        const response = await service.registerToSmaregi(this.smaregiProductId);
        this.smaregiResult = response.data;
      } catch (error) {
        this.handleSmaregiError(error);
      }
    },
    
    async updateSmaregiProduct() {
      try {
        this.smaregiResult = null;
        const response = await service.updateToSmaregi(this.smaregiProductId);
        this.smaregiResult = response.data;
      } catch (error) {
        this.handleSmaregiError(error);
      }
    },
    
    async deleteSmaregiProduct() {
      try {
        this.smaregiResult = null;
        const response = await service.deleteToSmaregi(this.smaregiProductId);
        this.smaregiResult = response.data;
      } catch (error) {
        this.handleSmaregiError(error);
      }
    },
    
    async getSmaregiOrderInfo() {
      try {
        this.smaregiResult = null;
        this.smaregiOrders = [];
        const response = await service.ordersToSmaregi();
        this.smaregiResult = response.data;
        if (response.data.success && response.data.orders) {
          this.smaregiOrders = response.data.orders;
        }
      } catch (error) {
        this.handleSmaregiError(error);
      }
    },

    async bulkDeleteAllSmaregiProducts() {
      if (!confirm('スマレジの全商品を削除します。よろしいですか？')) {
        return;
      }
      try {
        this.smaregiResult = null;
        
        const deleteResponse = await service.bulkDeleteAllFromSmaregi();
        this.smaregiResult = deleteResponse.data;
      } catch (error) {
        this.handleSmaregiError(error);
      }
    },

    async bulkRegisterSmaregiProducts() {
      if (!confirm('公開ステータスの商品の中からPriceByChannelTableでsales_channel_id=1かつsales_channel_product_idがNullまたは空の商品をスマレジに一括登録します。よろしいですか？')) {
        return;
      }
      try {
        this.smaregiResult = null;
        
        const registerResponse = await service.bulkRegisterToSmaregi();
        this.smaregiResult = registerResponse.data;
        
        if (registerResponse.data.success) {
          const totalCount = registerResponse.data.totalCount || 0;
          const failedCount = registerResponse.data.failedCount || 0;
          const successCount = totalCount - failedCount;
          this.smaregiResult.message = `商品一括登録が完了しました。成功: ${successCount}件、失敗: ${failedCount}件`;
        }
      } catch (error) {
        this.handleSmaregiError(error);
      }
    },
    
    async exportSmaregiCsv() {
      try {
        this.smaregiResult = null;
        this.smaregiResult = {
          success: true,
          message: 'CSV出力処理を開始しています...（処理に1〜2分かかる場合があります）'
        };
        
        const response = await service.exportSmaregiCsv();
        
        const timestamp = new Date().toISOString().replace(/[-:]/g, '').replace('T', '_').split('.')[0];
        const fileName = `smaregi_export_${timestamp}.zip`;
        
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        setTimeout(() => {
          window.URL.revokeObjectURL(url);
        }, 10000);
        
        this.smaregiResult = {
          success: true,
          message: 'CSV出力が完了しました'
        };
      } catch (error) {
        if (error.code === 'ECONNABORTED') {
          this.smaregiResult = {
            success: false,
            message: 'タイムアウトしました。もう一度お試しください。'
          };
        } else {
          this.handleSmaregiError(error);
        }
      }
    },
    
    handleSmaregiError(error) {
      console.error('スマレジAPI呼び出しエラー:', error);
      this.smaregiResult = {
        success: false,
        message: error.response?.data?.message || 'APIの呼び出しに失敗しました'
      };
    },
    
    onSmaregiCsvFileChange(event) {
      const file = event.target.files[0];
      this.smaregiCsvFile = file;
    },
    
    async uploadSmaregiProductIds() {
      if (!this.smaregiCsvFile) {
        this.smaregiResult = {
          success: false,
          message: 'CSVファイルを選択してください'
        };
        return;
      }
      
      try {
        this.smaregiResult = null;
        
        const formData = new FormData();
        formData.append('file', this.smaregiCsvFile);
        
        const response = await service.uploadSmaregiProductIds(formData);
        this.smaregiResult = response.data;
        
        if (response.data.success) {
          this.$refs.smaregiCsvFile.value = '';
          this.smaregiCsvFile = null;
        }
      } catch (error) {
        this.handleSmaregiError(error);
      }
    },
    
    async executeDeleteOldSoldProducts() {
      if (!confirm('発送後指定時間以上経過した商品を販売チャンネルから削除します。よろしいですか？')) {
        return;
      }
      try {
        this.batchResult = null;
        const response = await service.deleteOldSoldProducts();
        this.batchResult = response.data;
      } catch (error) {
        console.error('バッチ処理エラー:', error);
        this.batchResult = {
          success: false,
          message: error.response?.data?.message || 'バッチ処理の実行に失敗しました'
        };
      }
    }
  }
}
</script>

<style scoped>
.permission-error {
  margin: 20px 0;
}

.alert {
  padding: 15px;
  margin-bottom: 20px;
  border: 1px solid transparent;
  border-radius: 4px;
}

.alert-danger {
  color: #721c24;
  background-color: #f8d7da;
  border-color: #f5c6cb;
}

.batch-section {
  background-color: #fff3cd;
  padding: 15px;
  border-radius: 5px;
  margin-bottom: 20px;
  border: 1px solid #ffc107;
}

.tabs-container {
  margin-bottom: 20px;
}

.tabs {
  display: flex;
  border-bottom: 1px solid #dee2e6;
}

.tab {
  padding: 10px 20px;
  cursor: pointer;
  border: 1px solid transparent;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
  margin-bottom: -1px;
  background-color: #f8f9fa;
  margin-right: 5px;
}

.tab.active {
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff;
  color: #495057;
  font-weight: bold;
}

.test-section {
  background-color: #f8f9fa;
  padding: 20px;
  border-radius: 5px;
  margin-bottom: 20px;
}

.form-field-container {
  margin-bottom: 20px;
}

.form-label {
  font-weight: bold;
  margin-bottom: 5px;
  display: block;
}

.input-container {
  max-width: 300px;
}

.action-buttons {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.result-section {
  background-color: #f8f9fa;
  padding: 20px;
  border-radius: 5px;
}

.result-container {
  padding: 15px;
  border-radius: 5px;
  margin-top: 10px;
}

.success {
  background-color: #d4edda;
  border: 1px solid #c3e6cb;
}

.error {
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
}

.result-message {
  font-weight: bold;
  margin-bottom: 10px;
}

.result-details {
  margin-top: 15px;
}

.result-table {
  width: 100%;
  border-collapse: collapse;
}

.result-table.webhook-table thead th {
  padding: 10px 8px;
  text-align: left;
  border-bottom: 2px solid #ddd;
  background-color: #e9ecef;
  font-weight: bold;
  width: auto;
}

.result-table.order-table thead th {
  padding: 10px 8px;
  text-align: left;
  border-bottom: 2px solid #ddd;
  background-color: #e9ecef;
  font-weight: bold;
  width: auto;
}

.result-table th, .result-table td {
  padding: 8px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.result-table th {
  width: 30%;
  background-color: #f2f2f2;
}

.result-table.webhook-table td {
  word-break: break-all;
}

.result-table.order-table td {
  word-break: break-all;
}
</style>
